import { RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { THistoryMeeting } from '@/common/basis/types/database/thistory-meeting';

function App(props: {
  index: number;
  collectionList: THistoryMeeting.Item[];
  setIsOpenCollectionDetail: (isOpenCollectionDetail: boolean) => void;
  setCurrentCollectionIndex: (currentCollectionIndex: number) => void;
}) {
  const index = props.index;
  const collectionList = props.collectionList;
  const setIsOpenCollectionDetail = props.setIsOpenCollectionDetail;
  const setCurrentCollectionIndex = props.setCurrentCollectionIndex;

  const item = useMemo(() => collectionList[index], [collectionList, index]);
  const startedTime = useMemo(() => item?.startedTime, [item?.startedTime]);
  const { t } = useTranslation();

  return (
    <div
      className='m-3 flex cursor-pointer items-center justify-between overflow-hidden rounded-md bg-[rgba(19,20,21,.04)] py-2'
      onClick={() => {
        setCurrentCollectionIndex(index);
        setIsOpenCollectionDetail(true);
      }}
    >
      <div className='flex items-center justify-start'>
        <div className='h-8 overflow-hidden px-3'>
          <img className='h-8 w-8' src={require('@/common/basis/assets/video_finish_icon.png')} />
        </div>
        <div className='text-[15px]'>
          <span>{dayjs(startedTime).format(`${t('MMDDFormat')}`)}</span>
          <span className='mx-2'>{dayjs(startedTime).format('ddd')}</span>
          <span>{dayjs(startedTime).format('HH:mm')}</span>
        </div>
      </div>
      <div className='px-3'>
        <RightOutlined className='text-[#969799]' />
      </div>
    </div>
  );
}

export default App;
